import { z } from 'zod';
import { defineEndpoint } from '../define';
import { PlanTaskSchema } from './shapes';

/** Additive sync from the product templates' ClickUp filters; never removes. */
export const syncPlanTasks = defineEndpoint({
  method: 'POST',
  path: '/v1/release-plans/:planId/tasks/sync',
  params: z.object({ planId: z.string().uuid() }),
  query: z.object({}),
  body: z.undefined(),
  response: z.object({
    data: z.object({ added: z.number().int(), tasks: z.array(PlanTaskSchema) }),
  }),
});
